import { HttpClient } from '@angular/common/http';
import { SignatureParticipantLinkApiModel } from './models/signature-participant.api.model';
import { SignatureParticipantLinkViewModel } from './models/signature-participant.view-model';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/enviroments';
import { ProblemDetails } from 'src/app/common/interfaces/action-result.interface';


@Injectable({
  providedIn: 'root'
})
export class SignatureParticipantsService {
    constructor(private http: HttpClient) {}

    getSignatureParticipantLink(participantId: bigint): Observable<SignatureParticipantLinkViewModel>{
        return this.http.get<SignatureParticipantLinkApiModel>(`${environment.apiUrl}/v2/SignatureParticipants/${participantId}/link`)
        .pipe(
            map(responseApi => {
                return {
                    participantId: responseApi.participantId,
                    link: responseApi.link,
                    isEnabled: responseApi.isEnabled,
                    reason: responseApi.reason
                };
            }),
            catchError((error: HttpErrorResponse) => {
                let extractedErrorMessage = 'Ha ocurrido un error inesperado';
                console.error('Error fetching signature participant link:', error);
                if(error.error && typeof error.error === 'object') {
                    const problemDetails = error.error as ProblemDetails;

                    if(problemDetails.detail) {
                        extractedErrorMessage = problemDetails.detail;
                    }

                }
               return throwError(() => ({
                    status: error.status,
                    message: extractedErrorMessage,
                    originalError: error
               }));
            })
        );
    }

}
